import { Injectable } from '@angular/core';
import { HttpService } from 'services/http/http.service';
import { ShowIfHttpError } from '@certemy/common';
import { Observable } from 'rxjs';
import { buildQueryParams, createQueryParam } from 'utils/helpers';
import _isUndefined from 'lodash-es/isUndefined';
import _forOwn from 'lodash-es/forOwn';
import { GENERATE_REPORT_RESPONSE_TYPE, PUBLIC_REPORT_PARAM_NAME, REPORT_FORMAT } from './report-generate.constants';
import { GenerateReportOption } from './report-generate.interface';
import {
  REPORT_OPTION,
  REPORT_OPTION_FORMAT_MAP,
} from 'features/report-generate/report-print-export-options/report-print-export-options.constants';

@Injectable()
export class ReportGenerateService {
  constructor(private http: HttpService) {}

  @ShowIfHttpError('Cannot generate report')
  getGeneratedReportBuffer(options: GenerateReportOption, reportOption: REPORT_OPTION): Observable<ArrayBuffer> {
    return this.generateReport<ArrayBuffer>(
      { ...options, reportFormat: REPORT_OPTION_FORMAT_MAP[reportOption] },
      GENERATE_REPORT_RESPONSE_TYPE.ARRAY_BUFFER,
    );
  }

  @ShowIfHttpError('Cannot generate report')
  getGeneratedReportHtml(options: GenerateReportOption): Observable<string> {
    return this.generateReport<string>(
      { ...options, reportFormat: REPORT_FORMAT.HTML },
      GENERATE_REPORT_RESPONSE_TYPE.TEXT,
    );
  }

  private generateReport<T>(
    {
      transcriptFormat,
      transcriptFilterId,
      reportType,
      reportFormat,
      auditId,
      voucherInstanceId,
      additionalParams,
    }: GenerateReportOption,
    responseType: GENERATE_REPORT_RESPONSE_TYPE,
  ): Observable<T> {
    const additionalParamsArr = [];
    let publicReport = false;
    if (additionalParams) {
      _forOwn(additionalParams, (value, key) => {
        if (key === PUBLIC_REPORT_PARAM_NAME) {
          publicReport = value;
          return;
        }
        additionalParamsArr.push(createQueryParam(key, value));
      });
    }
    const queryParams = buildQueryParams(
      [
        createQueryParam('report_format', `${reportFormat}`),
        createQueryParam('report_type_id', `${reportType}`),
        !_isUndefined(transcriptFormat) && createQueryParam('transcript_format', `${transcriptFormat}`),
        transcriptFilterId && createQueryParam('transcript_filter_by_id', transcriptFilterId),
        auditId && createQueryParam('audit_id', auditId),
        voucherInstanceId && createQueryParam('voucher_instance_id', voucherInstanceId),
        ...additionalParamsArr,
      ].filter(Boolean),
    );

    const url = `/report/generate${publicReport ? '/public' : ''}`;

    return this.http.get(`${url}${queryParams}`, { responseType });
  }
}
